import React from 'react';
import PropTypes from 'prop-types';

import './SeparatorWithTitle.scss';
import { HorizontalSeparator } from '../..';

const SeparatorWithTitle = ({ title, number })=> {
  return (
    <div className="separator-with-title">
      <HorizontalSeparator/>
      <div className="separator-with-title__text" >
        {number > 0 &&
          <p className="separator-with-title__text__number">{number}</p>
        }
        <p className="separator-with-title__text__title">{title}</p>
      </div>
      <HorizontalSeparator/>
    </div>
  );
};

SeparatorWithTitle.propTypes = {
  number: PropTypes.number,
  title: PropTypes.string
};

SeparatorWithTitle.defaultProps = {
  number: 0,
  title: ''
};

export default SeparatorWithTitle;
